import {EntityTypes, EntityLabels} from 'Store/investorProfile/profilesStore';
import type {EntityTypeItem} from 'Store/investorProfile/profilesStore';
import {
  steps,
  InvestorProfileSteps,
} from 'Store/investorProfile/currentStepStore';
import ContactIcon from 'Components/Common/icons/Contact.svelte';
import ContactPairIcon from 'Components/Common/icons/ContactPair.svelte';
import CorporationIcon from 'Components/Common/icons/Corporation.svelte';
import BankIcon from 'Components/Common/icons/Bank.svelte';
import ShieldDollarIcon from 'Components/Common/icons/ShieldDollar.svelte';
import {entity} from 'Store/ibex/checkouts/profileStore';
import {get} from 'svelte/store';
import type {EntityType} from 'Store/investorProfile/entityStore';

export const jointTypeTooltipText =
  'Joint tenant holdings include survivorship rights; the last surviving tenant will own any securities purchased. Tenants-in-common holdings allow tenants to agree on who owns how much of the securities purchased. Community property holdings, like joint tenancy, include survivorship rights but are only for married couples.';

export const onClick = (type: EntityType, step: InvestorProfileSteps): void => {
  steps.push(step);
  entity.set({...get(entity), type: type});
};

export const ENTITY_TYPES: EntityTypeItem[] = [
  {
    step: InvestorProfileSteps.CREATE_INDIVIDUAL,
    type: EntityTypes.INDIVIDUAL,
    icon: ContactIcon,
    label: EntityLabels.INDIVIDUAL,
    onClick: onClick,
  },
  {
    step: InvestorProfileSteps.CREATE_JOINT,
    type: EntityTypes.JOINT,
    icon: ContactPairIcon,
    label: EntityLabels.JOINT,
    onClick: onClick,
  },
  {
    step: InvestorProfileSteps.CREATE_CORPORATION,
    type: EntityTypes.CORPORATION,
    icon: CorporationIcon,
    label: EntityLabels.CORPORATION,
    onClick: onClick,
  },
  {
    step: InvestorProfileSteps.CREATE_TRUST,
    type: EntityTypes.TRUST,
    icon: BankIcon,
    label: EntityLabels.TRUST,
    onClick: onClick,
  },
  {
    step: InvestorProfileSteps.CREATE_MANAGED,
    type: EntityTypes.MANAGED,
    icon: ShieldDollarIcon,
    label: EntityLabels.MANAGED,
    onClick: onClick,
  },
];

export const stepByEntityType = (type: EntityType): string =>
  ENTITY_TYPES.find(item => item.type === type)?.step;

export const labelByEntityType = (type: EntityType): string =>
  ENTITY_TYPES.find(item => item.type === type)?.label;

export const SelectItems = ENTITY_TYPES.map(item => {
  return {
    value: item.type,
    label: item.label,
  };
});
